import React from 'react';
import styled from 'styled-components';
import { FiHelpCircle } from 'react-icons/fi';

const CartTotal = ({ label, price, small, tooltip, ...props }) => {
  return (
    <TotalWrap small={small} {...props}>
      {label}
      <div>
        {price && <span>{price}</span>}
        {tooltip && <FiHelpCircle data-tooltip-id="cart-tooltip" data-tooltip-content={tooltip} />}
      </div>
    </TotalWrap>
  );
};

export default CartTotal;

const TotalWrap = styled.span`
    padding: ${props => props.small ? '0.2rem' : '0.8rem'} 0;
    text-transform: uppercase;
    letter-spacing: 2px;
    display: flex;
    justify-content: space-between;
    font-size: ${props => props.small ? '14px' : '16px'};
    font-weight: ${props => props.small ? '400' : '600'};
    margin-bottom: 6px;

    svg {
        font-size: 20px;
    }

    div {
      display: flex;
      align-items: center;
      gap: 5px;
      text-transform: none;
      letter-spacing: 1.1px;
    }
`;
